import { useQuery } from '@apollo/client'
import { useSearchParams } from 'react-router'

import { useAddressStore } from '@entities/Address/model/useAddressStore'
import { parseBlockPayload } from '@entities/MainPageConfig/model/helpers'
import { GQL_QUERY_MAIN_PAGE_CONFIG } from '@entities/MainPageConfig/model/queries'
import type { MainPageConfig, MainPageConfigQuery } from '@entities/MainPageConfig/model/types'


export function useMainPageConfig () {
  const [ searchParams ] = useSearchParams()
  const deliveryType = useAddressStore((state) => state.deliveryType)

  const id = searchParams.get('id') || undefined
  const type = deliveryType === 'shop' ? 'shop' : 'delivery'
  const ignoreCache = !!id

  const { data, loading, error, refetch } = useQuery<MainPageConfigQuery>(GQL_QUERY_MAIN_PAGE_CONFIG, {
    variables: {
      id,
      type,
      ignoreCache,
    },
    fetchPolicy: 'cache-and-network',
  })

  const mainPageConfig: MainPageConfig | undefined = data?.mainPageConfig
    ? {
      ...data.mainPageConfig,
      blocks: data.mainPageConfig.blocks.map((block) => ({
        ...block,
        payload: parseBlockPayload(block),
      })),
    }
    : {
      id: 'default',
      blocks: [],
    }

  return {
    mainPageConfig,
    data,
    loading,
    error,
    refetch,
  }
}